import http from "./constants/http";
import resources from "./constants/resources";

export const postFCM = async (body) => {
  const res = await http(resources.FCM).post(body);

  if (res.stats === 200) {
    return res.data;
  } else {
    return res;
  }
};
